import { Button } from '@tremor/react';
import { ComponentProps, FC } from 'react';
import s from './TagSelection.module.scss';
import { PriceTagIcon, PriceTagIconWhite, CheckmarkIcon } from '@/assets';

interface Props extends ComponentProps<typeof Button> {
  isSelected: boolean;
}

export const TagContainer: FC<Props> = ({ children, className, isSelected, ...rest }) => {
  return (
    <Button
      type="button"
      icon={() => (
        <img src={isSelected ? PriceTagIconWhite : PriceTagIcon} alt="price tag icon" />
      )}
      className={[s.tagButton, isSelected ? s.tagButtonSelected : '', className].join(
        ' ',
      )}
      {...rest}
    >
      <span>{children}</span>
      <img src={CheckmarkIcon} alt="checkmark icon" />
    </Button>
  );
};
